export const displayUserImg = (img: string | null) => {
    if (img) {
        return img;
    } else {
        return '/assets/img/user.png';
    }
};
